"use strict";

exports.__esModule = true;
exports.LogicalOperators = exports.ConditionTypes = void 0;
var ConditionTypes = exports.ConditionTypes = [{
  key: "CONDITION_TYPE",
  displayName: "Condition"
}, {
  key: "CYCLE_CLASSIFY_TYPE",
  displayName: "Cycle Classification"
}, {
  key: "DATA_ITEM_TYPE",
  displayName: "Data Item"
}, {
  key: "MESSAGE_TYPE",
  displayName: "Message"
}, {
  key: "USER_INPUT_TYPE",
  displayName: "User Input"
}];
var LogicalOperators = exports.LogicalOperators = [{
  value: "OR",
  displayName: "OR"
}, {
  value: "AND",
  displayName: "AND"
}];